import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = 'your-32-char-secret-key-123456789012'; // Must match backend!

export const encrypt = (data) => {
    try {
        const jsonStr = typeof data === 'string' ? data : JSON.stringify(data);
        return CryptoJS.AES.encrypt(jsonStr, ENCRYPTION_KEY).toString();
    } catch (error) {
        console.error('Encryption failed:', error);
        return '';
    }
};

export const decrypt = (ciphertext) => {
    try {
        if (!ciphertext) return '';
        const bytes = CryptoJS.AES.decrypt(ciphertext, ENCRYPTION_KEY);
        const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
        try {
            return JSON.parse(decryptedStr);
        } catch (e) {
            return decryptedStr;
        }
    } catch (error) {
        console.error('Decryption failed:', error);
        return ciphertext; // Return original if decryption fails (might be already decrypted)
    }
};
